// extracted by mini-css-extract-plugin
export default {"about":"About_about__FAXt2","descirption":"About_descirption__QsijW","wordsPart":"About_wordsPart__pX-Zk","profile":"About_profile__f+Hx6"};